// extracted by mini-css-extract-plugin
export default {"block":"y9ECzpY","fakeOutsideBlock":"_3p_dt_D"};